export enum Language {
  Swedish = 'sv-SE',
  English = 'en-US',
}
